import store_laboratoire from '@/store/mods/analyses/laboratoire'
import annuaire from '@/api/config/_user'
import { libelle_type_echantillon, MOTIFS_REJET } from '@/utils/etiquettes-echantillons'
import EchantillonExterne from '@/views/tableau-de-bord/reception-echantillons/echantillon-externe'

// LAB-003 : réception au laboratoire des échantillons prélevés en unité de soins, et échantillons externes.
// LAB-009 : une seule liste (en attente), origine dans le tableau, dépôt tracé (qui a apporté, à quelle heure) ; accepté => Technique.
export const DECISIONS = [
    { id: 'accepte', libelle: 'Accepté' },
    { id: 'accepte_avec_reserve', libelle: 'Accepté avec réserve' },
    { id: 'rejete', libelle: 'Rejeté (nouveau prélèvement)' }
]

// Repli si le référentiel de la Clinique n'est pas chargé
export const MOTIFS_DEFAUT = MOTIFS_REJET

const message = (error, fallback) => error && error.response && error.response.data && typeof error.response.data.message === 'string' ? error.response.data.message : fallback

export default {
    name: 'reception-echantillons',
    components: { EchantillonExterne },
    props: { integre: { type: Boolean, default: false } },   // LAB-UI-2 : integre = dans la carte du circuit
    data() {
        return {
            onglet: 'attente',
            vue: 'analyses',
            recherche: '', page: 1, pages: 1, total: 0,
            lignes: [], compteurs: null, is_loading: false, erreur: '', info: '', sequence: 0, detruit: false, search_timer: null,
            coches: [],
            decisions: DECISIONS, motifs: MOTIFS_DEFAUT,
            modal: false, decision: 'accepte', motif: '', commentaire: '', is_saving: false, erreur_modal: '',
            depose_par: '', depose_at: '',   // LAB-009 : dépôt
            porteurs: [], porteurs_loading: false, porteurs_erreur: '', porteur_selection: '',
            externe_toggler: 0
        }
    },

    watch: {

    },

    computed: {
        selection() {
            return this.lignes.filter(ligne => this.coches.indexOf(ligne.id) !== -1)
        },

        motif_obligatoire() {
            return this.decision !== 'accepte'
        },

        // Lignes regroupées par bon pour la lecture (un bon = plusieurs tubes)
        bons() {
            const groupes = []
            this.lignes.forEach((ligne) => {
                let groupe = groupes.filter(g => g.bulletin_id === ligne.bulletin_id)[0]
                if (!groupe) {
                    groupe = { bulletin_id: ligne.bulletin_id, reference: ligne.reference, patient: ligne.patient, prescripteur: ligne.prescripteur, echantillons: [] }
                    groupes.push(groupe)
                }
                groupe.echantillons.push(ligne)
            })
            return groupes
        },
        rangees() {
            if (this.vue === 'patients') return this.bons.map(bon => ({ key: 'bon-' + bon.bulletin_id, bon, ligne: bon.echantillons[0], analyses: [...new Set(bon.echantillons.reduce((liste, ligne) => liste.concat(ligne.analyses || []), []))], echantillons: bon.echantillons }))
            return this.bons.reduce((liste, bon) => liste.concat(bon.echantillons.map((ligne, index) => ({ key: 'ech-' + ligne.id, bon, ligne, index, analyses: ligne.analyses || [], echantillons: [ligne] }))), [])
        }
    },

    mounted() {
        this.charger()
        this.charger_referentiel()
    },

    beforeDestroy() {
        this.detruit = true
        this.sequence++
        clearTimeout(this.search_timer)
    },

    methods: {
        charger() {
            if (this.detruit) return Promise.resolve()
            const sequence = ++this.sequence
            const data = { state: this.onglet, page: this.page, search_item: this.recherche.trim() }
            this.is_loading = true
            this.erreur = ''
            return store_laboratoire.getReceptionListe(data).then((result) => {
                if (this.detruit || sequence !== this.sequence) return
                if (!result || !Array.isArray(result.data) || !result.counts) throw new Error('Réponse invalide')
                this.lignes = result.data
                this.compteurs = result.counts
                this.total = result.total
                this.pages = Math.max(1, result.last_page)
                this.coches = this.coches.filter(id => this.lignes.some(ligne => ligne.id === id))
                this.is_loading = false
            }).catch((error) => {
                if (this.detruit || sequence !== this.sequence) return
                this.lignes = []
                this.compteurs = null
                this.total = 0
                this.is_loading = false
                this.erreur = message(error, 'Impossible de charger la réception. Réessayez avec Actualiser.')
            })
        },

        charger_referentiel() {
            return store_laboratoire.getReferentiel().then((response) => {
                if (response && response.success && response.data && response.data.motifs_rejet) {
                    const motifs = []
                    Object.keys(response.data.motifs_rejet).forEach((id) => { motifs.push({ id: id, libelle: response.data.motifs_rejet[id] }) })
                    if (motifs.length) this.motifs = motifs
                }
            }).catch(() => {
                this.motifs = MOTIFS_DEFAUT
            })
        },

        chercher() {
            clearTimeout(this.search_timer)
            this.search_timer = setTimeout(() => { this.page = 1; this.charger() }, 300)
        },

        aller_page(page) {
            if (page >= 1 && page <= this.pages) { this.page = page; this.charger() }
        },

        est_coche(id) {
            return this.coches.indexOf(id) !== -1
        },

        cocher(id) {
            if (this.est_coche(id)) {
                this.coches = this.coches.filter(coche => coche !== id)
            } else {
                this.coches = this.coches.concat([id])
            }
        },

        choisir_vue(vue) {
            if (vue === 'analyses' || vue === 'patients') this.vue = vue
        },

        cocher_bon(bon, coche) {
            const ids = bon.echantillons.map(ligne => ligne.id)
            this.coches = coche ? [...new Set(this.coches.concat(ids))] : this.coches.filter(id => !ids.includes(id))
        },

        bon_coche(bon) {
            return bon.echantillons.every(ligne => this.est_coche(ligne.id))
        },

        // Sélectionne tous les tubes en attente d'un bon puis ouvre la réception
        receptionner_bon(bulletin_id) {
            this.coches = this.lignes.filter(ligne => ligne.bulletin_id === bulletin_id && ligne.etat === 'preleve').map(ligne => ligne.id)
            this.ouvrir_reception()
        },

        ouvrir_reception() {
            if (!this.coches.length) return
            this.decision = 'accepte'
            this.motif = ''
            this.commentaire = ''
            const deposants = [...new Set(this.selection.map(ligne => String(ligne.depose_par_nom || '').trim()).filter(Boolean))]
            this.depose_par = deposants.length === 1 ? deposants[0] : ''
            this.porteur_selection = ''
            this.depose_at = this.maintenant_local()
            this.erreur_modal = ''
            this.modal = true
            this.charger_porteurs()
        },

        charger_porteurs() {
            this.porteurs_loading = true
            this.porteurs_erreur = ''
            return annuaire.getMinimalUsersInfo().then((users) => {
                this.porteurs = (Array.isArray(users) ? users : [])
                    .filter(personne => personne && personne.name && Array.isArray(personne.roles) && personne.roles.some(role => role && ['ROLE_INFIRMIER', 'ROLE_TECH_SUP_LABO'].indexOf(role.nom) !== -1))
                    .map(personne => ({
                        id: personne.id,
                        name: personne.name,
                        fonction: personne.roles.some(role => role && role.nom === 'ROLE_TECH_SUP_LABO') ? 'Laboratoire' : 'Infirmier'
                    }))
                    .sort((a, b) => a.name.localeCompare(b.name, 'fr'))
                const correspondant = this.porteurs.find(personne => personne.name === this.depose_par)
                if (this.depose_par) this.porteur_selection = correspondant ? String(correspondant.id) : 'autre'
                this.porteurs_loading = false
            }).catch(() => {
                this.porteurs = []
                if (this.depose_par) this.porteur_selection = 'autre'
                this.porteurs_loading = false
                this.porteurs_erreur = 'Annuaire indisponible. Choisissez « Autre personne » pour saisir le nom.'
            })
        },

        selectionner_porteur() {
            const personne = this.porteurs.find(item => String(item.id) === this.porteur_selection)
            this.depose_par = personne ? personne.name : ''
        },

        // LAB-009 : heure locale « AAAA-MM-JJTHH:MM » pour le champ de dépôt (par défaut : maintenant)
        maintenant_local() {
            const d = new Date(), deux = n => (n < 10 ? '0' : '') + n
            return d.getFullYear() + '-' + deux(d.getMonth() + 1) + '-' + deux(d.getDate()) + 'T' + deux(d.getHours()) + ':' + deux(d.getMinutes())
        },

        libelle_origine(ligne) {
            if (ligne.origine === 'externe') return 'Externe' + (ligne.provenance_externe ? ' — ' + ligne.provenance_externe : '')
            return ligne.origine === 'laboratoire' ? 'Interne (labo)' : 'Interne — unité de soins'
        },

        afficher_lieu_prelevement(ligne) {
            const lieu = String(ligne && ligne.lieu_prelevement ? ligne.lieu_prelevement : '').trim()
            if (!lieu) return false
            if (ligne.origine === 'infirmier' && lieu.toLocaleLowerCase('fr-FR') === 'unité de soins') return false
            if (ligne.origine === 'laboratoire' && lieu.toLocaleLowerCase('fr-FR') === 'laboratoire') return false
            if (ligne.origine === 'externe' && lieu === ligne.provenance_externe) return false
            return true
        },

        enregistrer() {
            if (this.is_saving || !this.coches.length) return Promise.resolve()
            if (this.motif_obligatoire && !this.motif) {
                this.erreur_modal = 'Indiquez le motif de la réserve ou du rejet.'
                return Promise.resolve()
            }
            this.is_saving = true
            this.erreur_modal = ''
            const data = {
                echantillon_ids: this.coches.slice(),
                decision: this.decision,
                motif_rejet: this.motif_obligatoire ? this.motif : null,
                commentaire: this.commentaire ? this.commentaire.trim() : null,
                depose_par_nom: this.depose_par.trim() ? this.depose_par.trim() : null,
                depose_at: this.depose_at ? String(this.depose_at).replace('T', ' ').substr(0, 16) : null
            }
            return store_laboratoire.enregistrerReception(data).then((response) => {
                if (this.detruit) return
                if (!response || response.success !== true) throw new Error('Réception refusée')
                this.info = response.message || 'Réception enregistrée.'
                this.modal = false
                this.coches = []
                this.is_saving = false
                return this.charger()
            }).catch((error) => {
                if (this.detruit) return
                this.is_saving = false
                this.erreur_modal = message(error, 'La réception n\'a pas été enregistrée. Actualisez puis réessayez.')
            })
        },

        ouvrir_externe() {
            this.externe_toggler = (this.externe_toggler === 0) ? 1 : 0
        },

        apres_externe(resultat) {
            this.info = resultat && resultat.reference ? 'Échantillon externe enregistré (bon ' + resultat.reference + ') : analyses à traiter dans l\'onglet Technique.' : 'Échantillon externe enregistré : analyses à traiter dans l\'onglet Technique.'
            this.page = 1
            this.charger()
        },

        libelle_type(type) {
            return libelle_type_echantillon(type)
        },

        libelle_decision(decision) {
            const trouve = DECISIONS.filter(item => item.id === decision)
            return trouve.length ? trouve[0].libelle : (decision || '')
        },

        libelle_motif(code) {
            if (!code) return ''
            const trouve = this.motifs.filter(item => item.id === code)
            return trouve.length ? trouve[0].libelle : code
        },

        date_heure(value) {
            if (!value) return 'Non renseignée'
            const texte = String(value).replace('T', ' ')
            const morceaux = texte.split(' ')
            const date = morceaux[0].split('-')
            if (date.length !== 3) return texte
            const heure = morceaux.length > 1 ? morceaux[1].substr(0, 5) : ''
            return date[2] + '/' + date[1] + '/' + date[0] + (heure ? ' ' + heure : '')
        }
    }
}
